import { styled } from '@/styles/stitches';

export const ContainerAuthRoute = styled('div', {
  minHeight: '100vh',
  display: 'flex',
});

export const WrapperAuthRoute = styled('div', {
  width: '100%',
  backgroundColor: '$gray-100',
  position: 'relative',
  maxWidth: 'calc(100% - 12rem)',
});

export const WrapperChildren = styled('div', {
  height: '100%',
  minHeight: '100vh',
  padding: '5rem $12 0 $12',

  hr: {
    borderColor: '$gray-300',
    borderStyle: 'solid',
  },

  '@sm': {
    padding: '5rem $7',
  },
});
